export const iconFontAwesomeShapesCrown = (
	<i className="fa-solid fa-crown"></i>
);
